<template>
<div>
    <v-dialog v-model="dialogproject" max-width="450px" persistent>
        <v-toolbar dark color="white">

            <v-toolbar-title>  <h3 class="titleText--text">{{parmVariablename}}</h3></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn icon dark @click="Closewindow()">
                   <v-icon color="black">mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
       <!-- {{this.Itemgrd}}-->
        <v-simple-table>
            <template v-slot:default>
  <thead>
                <tr>
                  <th class="grey-bg"></th>
                  <th
                    class="text-center titleText--text font-weight-bold grey-bg"
                  >
                    {{ "Region" | tableheader }}
                  </th>
                  <th
                    class="text-center titleText--text font-weight-bold grey-bg"
                  >
                    Coefficient
                  </th>
                 
                </tr>
              </thead>
                <tbody>
                    <tr v-for="item in Itemgrd" :key="item.id">
                         <td class="blue-bg text-center darkGrey--text">{{ item.id }}</td>
                         <td class="blue-bg text-center darkGrey--text">{{ item.region }}</td>
                         <td class="blue-bg text-center darkGrey--text">
<v-edit-dialog
                      :return-value.sync="item.coeff"
                      @cancel="cancel"
                      @open="open"
                      @close="close"
                      @save="
                        updatemodelsaveoffset(
                          item.id,
                          item.variable,
                          item.region,
                          item.coeff,
                          item.tvalue
                        )
                      "
                      large
                    >
                    
                      {{String(item.coeff)|trgm_numberformate}}
                      <template v-slot:input>
                        <v-text-field
                          v-model="item.coeff"
                          label="Edit"
                          single-line
                          class="text-center"
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>

                         </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </v-dialog>

</div>
</template>

<script>
import numeral from 'numeral';
//import {bus} from '../../../main';
import apifactory from '../api';
import {
    defineComponent
} from '@vue/composition-api'

export default defineComponent({
    data: () => ({

        AdjustedRsquared: '',
        dialogproject: false,
        parmVariablename: '',
        Itemgrd: [],
        
    }),
    methods: {

        getdata() {

            this.Itemgrd = [];
            apifactory.get_model_roi_table()
                .then((res) => {
                    // alert(res.id);

                    if (res.status != 200) {
                        //this.countryList = null;
                        alert(res.message);

                    } else {

                        for (var i = 0; i < res.data.length; i++) {
                            if (res.data[i].variable === this.parmVariablename) {
                                let objvolume = new Object();
                                objvolume.name = "Volume";
                                objvolume.value = JSON.stringify(res.data[i].volume);

                                let objvolume_contribution = new Object();
                                objvolume_contribution.name = "Volume Contribution";
                                objvolume_contribution.value = JSON.stringify(res.data[i].volume_contribution) + " %";

                                let objvolume_response = new Object();
                                objvolume_response.name = "Volume Response";
                                objvolume_response.value = JSON.stringify(res.data[i].volume_response);

                                let objroi = new Object();
                                objroi.name = "ROI";
                                objroi.value = JSON.stringify(res.data[i].roi);

                                this.Itemgrd.push(objvolume);
                                this.Itemgrd.push(objvolume_contribution);
                                this.Itemgrd.push(objvolume_response);
                                this.Itemgrd.push(objroi);
                            }
                        }
                        // alert( this.Itemgrd.length);
                        let havedata = 0;
                        havedata = this.Itemgrd.length;
                        if (havedata > 0) {
                            this.dialogproject = true;
                        } else {
                            alert('No Data');
                        }

                        //this.ItemListmodeldepvarlist = [...Object.keys(res.data)]

                    }
                })
                .catch(function (error) {
                    console.warn(error);
                });
        },
        formatedatavalue(value) {
            let newval = String(value);
            let temarray = newval.split('.');
            let formatestr = numeral(temarray[0]).format('0,0');
            let result = formatestr;
            if (temarray.length > 1) {
                result = result + "." + temarray[1]
            }

            return `${result}`;
        },
        Refresh(varname,varcoffdata) {

            //alert('coffoffdatavuewrefresh' + varname);

            this.parmVariablename = varname;
            this.dialogproject=true;
            this.Itemgrd=varcoffdata;
           // this.getdata();
        },
        Closewindow(){
            this.$parent.GetDataClick();
            this.dialogproject=false;
        },
        updatemodelsaveoffset( varid,
                          varvariable,
                          varregion,
                          varcoeff,
                          vartvalue) {
                            //alert(varid + ""+varvariable+ ""+varregion+ ""+varcoeff+ ""+vartvalue);
                           
    
      apifactory
        .api_get_model_save_offset_update(varvariable, varregion, varcoeff, vartvalue,varid)
        .then((res) => {
          // alert(res.id);
          // alert(JSON.stringify(res));
          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            alert("Data Update");
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    },
    mounted() {

        //this.getadj_rsquared();
       // bus.$off('coffdatavuewrefresh');
       // bus.$on('coffdatavuewrefresh', this.Refresh);
    }
})
</script>

<style scoped>
.headerbox {
    font-weight: bold;
    font-style: italic;
    font-size: 25px;
    color: black;

}

.headerboxtitle {

    font-size: 20px;
}

.card2 {
    background-color: #FFFF00;
}
</style>
